












































import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({})
export default class FilterComponet extends Vue {
  dialog = false;
  lookup = this.$store.state.lookup;
  filter = {};

  @Prop({ default: null })
  value: any;

  mounted() {
    this.filter = this.value;
  }

  async loadItems(id: number) {
    this.$store.dispatch('lookup/getAvailableLookup', id);
  }

  getLookup(id: number) {
    return this.$store.getters['lookup/getAvailableLookupDetail'](id);
  }

  setFilter() {
    this.$emit('update-simpleFilter', this.filter);
    this.dialog = false;
  }

  discardFilter() {
    this.filter = {};
    this.$emit('update-simpleFilter', this.filter);
    this.dialog = false;
  }
}
